<template>
  <div>
    <div class="detial-cont-title">附件</div>
    <blank height="1"> </blank>
    <div class="detial-cont-view">
      <a-table
        :loading="loading"
        :pagination="false"
        :columns="columns"
        :data-source="upfileList"
        :row-key="(record) => record.mongoFileId"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ record.createTime ? record.createTime.slice(0, 10) : '' }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record)">
            查看
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="
              download(record.mongoFileId, record.filename, record.fileformat)
            "
          >
            下载
          </a-button>
          <a-divider type="vertical" v-if="!disabled" />
          <a-button
            type="link"
            class="btn-link"
            @click="removeFiles(record.mongoFileId)"
            v-if="!disabled"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="accessory-btn" v-if="!disabled">
        <!-- :before-upload="beforeUpload" -->
        <a-upload
          name="file"
          :multiple="false"
          :headers="headers"
          action="#"
          :fileList="fileList"
          @change="uploadFiles"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
        >
          <a-button @click="fileList = []"
            ><a-icon type="upload" />上传文件
          </a-button>
        </a-upload>
      </div>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '文档名称',
    dataIndex: 'filename',
    key: 'filename'
  },
  {
    title: '文件格式',
    dataIndex: 'fileformat',
    key: 'fileformat'
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
    key: 'createTime'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import { saveFile, getFile } from '@/http/url'
import { getSuffix, formatDate } from '@/assets/js/auth'
export default {
  props: ['disabled', 'updateList', 'file'],
  model: {
    event: 'input',
    prop: 'updateList'
  },
  data() {
    return {
      columns,
      data: [],
      headers: {
        Authentication: localStorage.getItem('token')
      },
      loading: false,
      fileList: [],
      upfileList: [] //上传成功的附件列表
    }
  },
  watch: {
    file(val) {
      this.upfileList = this.file
    }
  },
  mounted() {
    if (this.file) {
      this.upfileList = this.file
    }
  },
  methods: {
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    goDetial(item) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    // 移除
    removeFiles(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          let index = this.upfileList.findIndex(
            (item) => item.mongoFileId == id
          )
          this.updateList.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      this.$message.success('下载中')
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)
          this.$emit('input', this.upfileList)
        } else {
          this.$message.error('上传失败')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.detial-cont-title {
  background: #fff;
  height: 55px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 55px;
  text-align: left;
  padding-left: 32px;
}
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/accessories-table/index.vue